import React from 'react';
import Image from 'next/image';
import type { VideoCourse } from '@/types/video';

interface MediaLibraryCardProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  name: string;
  videos: VideoCourse[];
}

const MediaLibraryCard: React.FC<MediaLibraryCardProps> = ({
  imageSrc,
  imageAlt,
  title,
  name,
  videos,
}) => {
  return (
    <div
      className={`bg-white rounded-2xl gap-4 h-full flex-1 mb-5 md:mb-0 transition-all duration-300 hover:transform hover:scale-105`}
    >
      <div className="relative">
        <div className="relative w-full aspect-video">
          <Image src={imageSrc} alt={imageAlt} className="w-full rounded-2xl object-cover" fill />
        </div>
        <div className="absolute bg-white/30 backdrop-blur-[10px] bottom-5 left-5 p-2.5 rounded-full">
          {videos.length} videos
        </div>
      </div>
      <div className="flex-1 p-8 ">
        <h4 className="text-lg mb-8">{title}</h4>
        <p className="text-base opacity-50">{name}</p>
      </div>
    </div>
  );
};

export default MediaLibraryCard;
